import { icons } from '@/helpers/icons'

export const CATEGORIES_FILTER_ITEM = { icon: { is_local: true, value: icons.icon_multisport }, name: 'Categories', field: 'categories', key_name: 'categories' }
export const BRAND_FILTER_ITEM = { icon: 'heroicons:tag', name: 'Brand', field: 'brand', key_name: 'brand' }
export const ATTRIBUTE_FILTER_ITEM = { icon: 'heroicons:information-circle', name: 'Attribute', field: 'attributes', key_name: 'attribute' }
export const GRADED_FILTER_ITEM = { icon: 'heroicons:scale-20-solid', name: 'Graded', field: 'graded', key_name: 'graded' }
export const GRADE_FILTER_ITEM = { icon: 'heroicons:scale-20-solid', name: 'Grader', field: 'grader', key_name: 'grader' }

export const FILTERS_BLOCK_1 = [
  { icon: { is_local: true, value: icons.status_spinner }, name: 'Status', key_name: 'status' },
  // { icon: { is_local: true, value: icons.text_T }, name: 'Content' }
]

export const FILTERS_BLOCK_2 = [
  CATEGORIES_FILTER_ITEM,
  BRAND_FILTER_ITEM,
  ATTRIBUTE_FILTER_ITEM,
  GRADED_FILTER_ITEM,
  GRADE_FILTER_ITEM
  // { icon: 'heroicons:currency-dollar', name: 'Price' },
  // { icon: 'heroicons:map-pin', name: 'Location' },
]

export const AVAILABLE_FILTERS = {
  attribute: [],
  brand: [],
  category: [],
  graded: [],
  grader: [],
  team: []
}
